<!-- 项目文件 -->
<template>
    <div class=" bgf6">
        <Header :Logo="logo" :img="bgImg" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" ></Header>
        <div class="w100p">
            <div class="w1200 mauto mt50 mb50 bgf6 overflow">
                <div>
                        <div class="textc mt20 mb20">
                            <p class="fs36 c333 disinblock posre">
                                <span class="border-bottom1">
                                    最新资讯
                                </span>
                            </p>
                        </div>
                        <div class="w100p h300">
                            <div class="item-ctn">
                                <div class=" floatl w3333p mb20" v-for="(item,index) in newsList.slice(0,3)" :key="index">
                                    <div class="mr40 fs0 cursor" @click="Todetail(item.id)" >
                                        <span class="disblock">
                                            <img class="w100p bradius8r h200" :src="item.image || 'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png'">
                                        </span>
                                        <p class="disblock pt10 pl10 pr10 pb10 fs0 bgfff brb8 minh120">
                                            <span class="disblock fs16 w100p over_1 c000"> {{item.title}} </span>
                                            <span class="fs12 c999 disblock mt5 mb5"> {{item.update_time | formatDate}}</span> 
                                            <span class="disblock over_2 fs14 c666 lh28"> {{item.text1}} </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                </div>
                <div>
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                热门资讯
                            </span>
                        </p>
                    </div>
                    <div class="overflow disflex fs0 mt15 mb10 bradius8" v-for="(item,index) in newsList" :key="index">
                        <span class="disinblock floatl">
                            <img class="w340 h190 " :src="item.image || 'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png'">
                        </span>
                        <div class="disinblock floatl bgfff h188  w80p pl20 pr20 bradius8r posre">
                            <p class="fs16 c000 pt15 pb5"> {{item.title}} </p>
                            <p class="fs12 c999 pt10 pb5">{{item.update_time | formatDate}} </p>
                            <p class="fs14 c666  pt10 over_2">
                                {{item.text1}}
                            </p>
                            <p class="pt15 pb5 posab bottom15">
                                <span @click="Todetail(item.id,Area_idX)" class="fs14 c1f8 bge8f bradius8 pt5 pb5 pl10 pr10 cursor">查看详情></span>
                            </p>
                        </div>
                    </div>
                    <div @click="pageadd()" class="fs18 textc c333 cursor"> {{loadingtype}}... </div>
                </div>
                
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                cityName: '',
                bgImg: require('../../public/img/img51.png'),
                newsList: [],
                hotList: [],
                Area_idX: '',
                page: 1,
                loadingtype: '点击加载更多...'
            };
        },
        components: {
            Header,
            Footer,

        },
        methods: {
            getNews() {
                let that = this;
                if (that.page == 1) {
                    that.newsList = [];
                }
                that.Area_idX = that.$route.query.cityid;

                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/find/getFindList.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "area_id": that.Area_idX,
                        "page": that.page
                    },
                    success: function(data) {
                        // that.newsList = data.obj;
                        if (data.obj.length == 0) {
                            that.loadingtype = "没有更多了";
                            return;
                        }
                        for (let i = 0; i < data.obj.length; i++) {
                            that.newsList.push(data.obj[i]);
                        }

                        for (let i = 0; i < that.newsList.length; i++) {
                            var strValue = that.newsList[i].content;
                            var re = new RegExp('<[^<>]+>', 'g');
                            var text1 = strValue.replace(re, "");
                            var text1 = text1.substring(0, 80);
                            that.$set(that.newsList[i], "text1", text1);
                            if (that.newsList[i].is_hot == 1) {
                                that.hotList.push(that.newsList[i])
                            }
                        }
                        that.$forceUpdate()
                        that.$store.dispatch('newsment').then(() => {
                            that.$store.state.newsDetail = that.newsList;
                        });
                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            pageadd() {
                this.page++;
                this.getNews();
            },
            Todetail(id, cityID) {
                let that = this;
                this.$router.push({
                    path: "/Newsdetail",
                    query: {
                        news_id: id,
                        cityid: cityID
                    }
                });
            },
        },
        filters: {
            formatDate(value) {
                var d = new Date(parseInt(value) * 1000);
                return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' +
                    (d.getDate() > 9 ? d.getDate() : '0' + d.getDate());
            }
        },
        created() {
            this.getNews();
            this.cityName = this.$store.state.cityName;
            console.log(11111111)
            console.log(this.cityName)
        },
        mounted() {

        },
    }
</script>
<style scoped>
    .item-ctn {
        margin-right: -20px;
        margin-bottom: -20px;
    }
    
    .item-ctn:after {
        content: '';
        display: block;
        clear: both;
    }
</style>